import store from '../store'
export default function pre_auth({ next, router }) {
  if (store.getters["auth/getUser"] != null) {
    return router.replace("/pos");
  }
  return next();
}